document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-root]');

  if (root) {
    const mainImage = root.querySelector('#ProductMainImage');
    const thumbs = root.querySelectorAll('[data-thumb-src]');

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!mainImage) return;

        const nextSrc = btn.dataset.thumbSrc;
        const nextAlt = btn.dataset.thumbAlt || mainImage.alt;

        if (nextSrc) {
          mainImage.removeAttribute('srcset');
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
        }

        thumbs.forEach((thumb) => thumb.classList.remove('active'));
        btn.classList.add('active');
      });
    });

    const qty = root.querySelector('#Quantity');
    root.querySelectorAll('[data-qty-minus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1);
      });
    });

    root.querySelectorAll('[data-qty-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (qty) qty.value = Number(qty.value || 1) + 1;
      });
    });

    root.querySelectorAll('[data-scroll-buy]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const appBlocks = root.querySelector('#ProductAppBlocks');
        const appContent = appBlocks && appBlocks.querySelector('.product-app-block');
        const nativeForm = root.querySelector('#ProductForm');
        const target = appContent || nativeForm || root.querySelector('.product-info');

        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }
});
